<template>
  <div class="container">
    <h4 class="title is-4">Tools</h4>
    <div class="level">
      <div class="level-left">
        <div class="level-item" v-if="hasPermission(31)">
          <router-link :to="{path: '/log'}">View Log</router-link>
        </div>
        <div class="level-item" v-if="hasPermission(31)">
          <router-link :to="{path: '/log/automations'}">Automations Log</router-link>
        </div>
        <div class="level-item" v-if="hasPermission(31)">
          <router-link :to="{path: '/tools/devices/locations'}">Devices Locations</router-link>
        </div>
        <div class="level-item" v-if="hasPermission(35)">
          <router-link :to="{path: '/tools/requester'}">Requester</router-link>
        </div>
        <div class="level-item">
          <router-link :to="{path: '/tools/timestamp'}">Timestamp Converter</router-link>
        </div>
        <div class="level-item">
          <router-link :to="{path: '/tools/uuid'}">UUID Generator</router-link>
        </div>
        <div class="level-item">
          <router-link :to="{path: '/tools/2fa'}">2FA</router-link>
        </div>
        <div class="level-item">
          <router-link :to="{path: '/tools/fido'}">FIDO</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';

  export default {
    name: "screentools",
    data() {
      return {};
    },
    computed: {
      ...mapGetters('auth', ['hasPermission'])
    },
    methods: {
      ...mapActions('log', ['fetchAutomationsLog'])
    },
    mounted() {
      if (this.hasPermission(31)) {
        this.fetchAutomationsLog();
      }
    }
  }
</script>

<style scoped>
  .level-item {
    margin-right: 1.5rem;
  }
</style>
